import { render, staticRenderFns } from "./BookingForms2.vue?vue&type=template&id=6e8ab11c&"
import script from "./BookingForms2.vue?vue&type=script&lang=js&"
export * from "./BookingForms2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports